import { useCustomClient } from '@uag/react-core';
import { AxiosError, AxiosRequestConfig, create } from 'axios';

export const notificationsApiClient = create({
    baseURL: `${import.meta.env.VITE_APP_NOTIFICATIONS_API_URL}`,
});

export type ErrorType<Error> = AxiosError<Error>;

export const useCustomNotificationsClient = <T,>(): ((config: AxiosRequestConfig) => Promise<T>) =>
    useCustomClient<T>(true, notificationsApiClient);
